/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientClearance
 */
export interface PatientClearance {
    /**
     * 
     * @type {string}
     * @memberof PatientClearance
     */
    clearance_id: string;
    /**
     * 
     * @type {number}
     * @memberof PatientClearance
     */
    remaining_uses?: number;
}

/**
 * Check if a given object implements the PatientClearance interface.
 */
export function instanceOfPatientClearance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clearance_id" in value;

    return isInstance;
}

export function PatientClearanceFromJSON(json: any): PatientClearance {
    return PatientClearanceFromJSONTyped(json, false);
}

export function PatientClearanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientClearance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clearance_id': json['clearance_id'],
        'remaining_uses': !exists(json, 'remaining_uses') ? undefined : json['remaining_uses'],
    };
}

export function PatientClearanceToJSON(value?: PatientClearance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clearance_id': value.clearance_id,
        'remaining_uses': value.remaining_uses,
    };
}

